import {PewComponent} from "../../../../themes/wwp_child_theme/assets/raw/js/components/pew-component";

export default class BonPlan extends PewComponent {

  init() {
    this.recomputeIndexes();
    this.registerSearch(true);
    this.registerPagination(this.element.find('.pagination'));
  }

  isMobile() {
    return (window.innerWidth < 768);
  }

  camelize(str) {
    return str.toLowerCase().replace(
      /([-_][a-z])/g,
      (group) => group.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    );
  }

  recomputeIndexes() {
    jQuery('.module-otca-bon-plan').each(function (i, instance) {
      $(instance).data('index', i);
    });
  }

  loadPage(href, isPagination, cb) {
    var self = this;
    this.element.addClass('ajax-loading');
    $.get(href, {}, (res) => {
      this.element.removeClass('ajax-loading');
      var index = this.element.data('index');
      var $newContext = null;
      if (index) {
        $newContext = $($(res).find('.module-otca-bon-plan')[index]);
        $newContext.data('index', index);
      } else {
        $newContext = $(res).find('.module-otca-bon-plan').first();
      }

      this.handleNewContext($newContext, isPagination, cb);
    });
  }

  handleNewContext($newContext, isPagination, cb) {
    const $newItems = $newContext.find('.items-otca-bon-plan > *');
    this.element.find('.items-otca-bon-plan > *').remove();
    this.element.find('.items-otca-bon-plan').append($newItems);

    this.replacePagination($newContext.find('.pagination'));

    if (window.pew) {
      window.pew.enhanceRegistry(this.element.find('.items-otca-bon-plan')[0]);
    }
    cb && cb();
  }

  registerPagination($pagination) {
    $pagination.find('a.navlink').on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).replaceWith('<span class="loader loader--small"></span>');
      this.loadPage(e.currentTarget.href, true, this.newPageLoaded.bind(this));
    })
  }

  newPageLoaded() {

  }

  replacePagination($newPagination) {
    this.element.find('.pagination').replaceWith($newPagination);
    this.registerPagination($newPagination);
  }

  registerSearch(autoSubmit) {
    const $filtersForm = this.element.find('form.bon-plan-filters');

    $filtersForm.on('submit', (e) => {
      e.preventDefault();
      if (!this.element.hasClass('ajax-loading')) {
        this.handleFiltersSubmit($filtersForm);
      }
    });
    if (autoSubmit) {
      $filtersForm.addClass('auto-submit');

      //auto submit on input change
      const $inputs = $filtersForm.find('.checkbox, input, select').not('.exclude');
      $inputs.on('change', function () {
        $(this).parent().addClass('currently-loading');
        $filtersForm.submit();
      });

      //Possibility to uncheck a radio input
      $("input:radio:checked").data("chk",true);
      $inputs.on('click', function () {
        $(this).data("chk",!$(this).data("chk"));
        $(this).prop("checked",$(this).data("chk")).trigger('change');
      });
    }
  }

  handleFiltersSubmit($filtersForm) {
    this.loadPage($filtersForm.prop('action') + '?' + $filtersForm.serialize());
  }

  serializeAssoc(rawFields) {
    let fields = {};
    $.each(rawFields, (i, field) => {
      fields[field.name] = field.value;
    });
    return fields;
  }

}

window.pew.addRegistryEntry({key: 'otca-bon-plan', classDef: BonPlan, domSelector: '.module-otca-bon-plan'});
